import { render, staticRenderFns } from "./JMax.vue?vue&type=template&id=75436fca"
import script from "./JMax.vue?vue&type=script&lang=js"
export * from "./JMax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports